import { useEffect, useRef, useState } from "react";
import "./Countdown.css";

const STEPS = ["3", "2", "1", "Start"];

// 3-2-1-Start intro played before a session view mounts. Each step is remounted
// with a new key so the CSS animation replays, which makes the change from one
// number to the next readable instead of an instant text swap.
// `active` gates the timer: the parent keeps the first step frozen on screen
// while it checks whether the student may enter the session.
const Countdown = ({ active = true, stepDuration = 700, onFinish } : { active?: boolean, stepDuration?: number, onFinish: () => void }) => {
    const [step, setStep] = useState<number>(0);
    const finishedRef = useRef<boolean>(false);

    useEffect(() => {
        if (!active || step >= STEPS.length - 1) return;
        const timer = setTimeout(() => setStep((current) => current + 1), stepDuration);
        return () => clearTimeout(timer);
    }, [active, step, stepDuration]);

    useEffect(() => {
        if (!active || step < STEPS.length - 1 || finishedRef.current) return;
        finishedRef.current = true;
        const timer = setTimeout(() => onFinish(), stepDuration);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, step, stepDuration]);

    const isStart = step === STEPS.length - 1;

    return (
        <div className="countdown-container">
            <span key={step} className={`countdown-step${isStart ? " countdown-step-start" : ""}`}>{STEPS[step]}</span>
        </div>
    );
};

export default Countdown;
